<template lang="pug">
.content-wrap.custom-font2
  .content-top
    .con.p-0
      main.fullBg(v-if="startRender == false")
        section.banner
          img.title-image(src='/new/img/events/feb-2026/title/title.png' alt='depo and unlock')
          .win-flowers
            img.title-win-image(src='/new/img/events/feb-2026/title/WIN-RM150.png' alt='win rm150')
            .flowers
              img.title-win-left-flower(width='80px' src='/new/img/events/feb-2026/title/flower-for-win-RM150-left.png' alt='win rm150')
              img.title-win-right-flower(width='80px' src='/new/img/events/feb-2026/title/flower-for-win-RM150-right.png' alt='win rm150')
        section.symbols-box
          .box-with-flag
            img.box-flag(src='/new/img/events/feb-2026/box_content/box.png' alt='box-with-flag')
            .symbols-div
              .title
                img(width='100%' src='/new/img/events/feb-2026/box_content/pick-and-win-RM150-text.png' alt='pick and win title')
              .symbols-grid
                .symbol-box
                  img.symbol(src='/new/img/events/feb-2026/symbols/flower-B.png' alt='bird symbol' data-value='flower-B.png')
                  img.pick-btn(v-if="choice ==''" src='/new/img/events/feb-2026/buttons/pick-button.png' alt='pick-btn' @click="pickGift('RAFFLESIA')")
                .symbol-box
                  img.symbol(src='/new/img/events/feb-2026/symbols/bird.png' alt='bird symbol' data-value='bird.png')
                  img.pick-btn(v-if="choice ==''" src='/new/img/events/feb-2026/buttons/pick-button.png' alt='pick-btn' @click="pickGift('RED')")
                .symbol-box
                  img.symbol(src='/new/img/events/feb-2026/symbols/flower-A.png' alt='bird symbol' data-value='flower-A.png')
                  img.pick-btn(v-if="choice ==''" src='/new/img/events/feb-2026/buttons/pick-button.png' alt='pick-btn' @click="pickGift('BLACK')")
                .symbol-box
                  img.symbol(src='/new/img/events/feb-2026/symbols/durian.png' alt='bird symbol' data-value='durian.png')
                  img.pick-btn(v-if="choice ==''" src='/new/img/events/feb-2026/buttons/pick-button.png' alt='pick-btn' @click="pickGift('PURPLE')")
                .symbol-box
                  img.symbol(src='/new/img/events/feb-2026/symbols/klcc-tower.png' alt='bird symbol' data-value='klcc-tower.png')
                  img.pick-btn(v-if="choice ==''" src='/new/img/events/feb-2026/buttons/pick-button.png' alt='pick-btn' @click="pickGift('CYAN')")
                .symbol-box
                  img.symbol(src='/new/img/events/feb-2026/symbols/nasi-lemak.png' alt='bird symbol' data-value='nasi-lemak.png')
                  img.pick-btn(v-if="choice ==''" src='/new/img/events/feb-2026/buttons/pick-button.png' alt='pick-btn' @click="pickGift('WHITE')")
            img.title-win-left-flower(width='80px' src='/new/img/events/feb-2026/title/flower-for-win-RM150-left.png' alt='win rm150')
            img.title-win-right-flower(width='80px' src='/new/img/events/feb-2026/title/flower-for-win-RM150-right.png' alt='win rm150')
            .selection-popup(v-if="choice!=''" :class="{'d-flex': choice!='' && !showSelected}")
              img.selection-recorded-img(src='/new/img/events/feb-2026/box_content/your-selection-have-been-recorded.png' alt='selection recorded')
              img#selected-symbol.selected-symbol(v-if="choice!=''" width='130px' :src="`/new/img/events/feb-2026/bare_symbol/${giftSelected[choice].src}.png`" alt='selected symbol')
              a.text-center.pointer(href="https://t.me/+X-6yIDpRAy04NzI9" target="_blank")
                img.selection-recorded-img(src='/new/img/events/feb-2026/box_content/please-stay-tuned.png' alt='selection recorded')
            .lock-popup(v-if="locked && choice==''" @click="checkStatus")
              img.lock-img(width='100%' src='/new/img/events/feb-2026/box_content/lock.png' alt='lock')
              img#deposit-unlock-btn.deposit-unlock-btn(src='/new/img/events/feb-2026/buttons/depo-and-unlock-button.png' alt='deposit and unlock')
          #chosen-symbol-popup.chosen-symbol-popup.d-flex(v-if="showConfirmation")
            .popup-img
              img#chosen-img.chosen-img(:src="`/new/img/events/feb-2026/popups/A/${giftPop[choice].src}.png`" alt='selected symbol')
            .actions
              img#cancel-btn(src='/new/img/events/feb-2026/buttons/cancel.png' alt='cancel selection' @click="cancelConfirmation")
              img#confirm-btn(src='/new/img/events/feb-2026/buttons/confirm.png' alt='confirm selection' @click="confirmSelection")
          #recorded-symbol-popup.recorded-symbol-popup.d-flex(v-if="showSelected && !showConfirmation")
            .popup-img
              img#recorded-img.recorded-img(:src="`/new/img/events/feb-2026/popups/B/${giftPop[choice].src}.png`" alt='selected symbol')
              img#back-btn.back-btn(src='/new/img/events/feb-2026/buttons/goback.png' alt='selected symbol' @click="hideSelected")
        section.t_c
          p
            template(v-if="getLanguage=='en'")
              h5 TERMS AND CONDITIONS
              ul
                li Players must accumulate a minimum deposit of RM200 to unlock the Blessings Lucky Bag Pick & Win event.
                li Eligible players can select one (1) symbol only, and it cannot be changed afterwards.
                li The winning symbol will be announced on 2nd March in the EpicWin Telegram group.
                li Players who selected the correct symbol can redeem their reward from 2nd March 12PM to 5th March 11.59PM.
                li Reward: RM250 bonus, with X8 turnover requirement.
                li Maximum withdrawal is capped at RM150.
                li Bonus is valid only for EpicWin, MegaH5, Fachai, Spade Gaming, and Habanero games.
              br
              h5 General Terms and Conditions 
              ul
                li Withdrawal is limited to 5 times per day.
                li EpicWin reserves all rights to terminate members' accounts in case of T&C violations without prior notice
                li Minimum withdrawal amount is RM10
            template(v-if="getLanguage=='my'")
              h5 TERMA DAN SYARAT
              ul
                li Pemain perlu mengumpul jumlah deposit minimum sebanyak RM200 untuk membuka acara Blessings Lucky Bag Pick & Win.
                li Pemain yang layak hanya boleh memilih satu (1) simbol sahaja, dan tidak boleh ditukar selepas itu.
                li Simbol pemenang akan diumumkan pada 2 March dalam kumpulan Telegram EpicWin.
                li Pemain yang memilih simbol yang betul boleh menebus hadiah mereka dari 2 March 12PM hingga 5 March 11.59PM.
                li Hadiah: Bonus RM250, dengan keperluan pertaruhan sebanyak 8x.
                li Pengeluaran maksimum dihadkan kepada RM150.
                li Bonus hanya sah untuk permainan EpicWin, MegaH5, Fachai, Spade Gaming, dan Habanero.
              br
              h5 Terma dan Syarat Umum
              ul
                li Pengeluaran dihadkan kepada 5 kali sehari.
                li EpicWin berhak menamatkan akaun ahli sekiranya berlaku pelanggaran T&C tanpa notis awal.
                li Jumlah pengeluaran minimum ialah RM10.
            template(v-if="getLanguage=='zh'")
              h5 条款与条件
              ul
                li 玩家需累计至少 RM200 的存款，方可解锁选福袋 ● 接福气活动。
                li 符合资格的玩家只能选择 一个（1）图标，且 选择后不可更改。
                li 获胜图标将于 3月2日 在 EpicWin Telegram 群组中公布。
                li 选中正确图标的玩家可在 3月2日 12PM 至 3月5日 11.59PM 期间兑换奖励。
                li 奖励： RM250 奖金，需达成 8倍流水要求。
                li 最高可提款金额为 RM150。
                li 奖金仅适用于 EpicWin、MegaH5、Fachai、Spade Gaming 和 Habanero 游戏。
              br
              h5 一般条款与细则
              ul
                li 每天最多可提款 5 次。
                li EpicWin 有权在无须预先通知的情况下终止违反条款与条件的会员账户。
                li 最低提款金额为 RM10。
</template>
<script>
export default{
	data(){
		return{
      startRender: false,
			locked: true,
			showConfirmation: false,
			showSelected:false,
			choice: "",
			gift:{
				"RAFFLESIA": { src: "flower-B" },
				"RED": { src: "bird" },
				"BLACK": { src: "flower-A" },
				"PURPLE": { src: "durian" },
				"CYAN": { src: "klcc-tower" },
				"WHITE": { src: "nasi-lemak" },
			},
      giftPop:{
				"RAFFLESIA": { src: "flower-b" },
				"RED": { src: "bird" },
				"BLACK": { src: "flower-a" },
				"PURPLE": { src: "durian" },
				"CYAN": { src: "klcc-tower" },
				"WHITE": { src: "nasi-lemak" },
			},
      giftSelected:{
				"RAFFLESIA": { src: "flower-b" },
				"RED": { src: "bird" },
				"BLACK": { src: "flower-a" },
				"PURPLE": { src: "durian" },
				"CYAN": { src: "klcc-tower" },
				"WHITE": { src: "nasi-lemak" },
			},
		}
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
	watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.locked = true
				this.choice = ""
      }else{
				this.eurocupCheck()
      }
    }
  },
  mounted(){
    document.body.classList.add("custom-padding");
		this.eurocupCheck()
  },
	methods:{
		checkStatus(){
			if(this.isLoggedIn){
				this.$router.push("/deposit").catch(err => {});
			}else{
				this.$router.push("/login").catch(err => {});
			}
		},
		pickGift(option){
      this.choice = option
      this.showConfirmation = true
			this.showSelected=true
    },
		cancelConfirmation(){
			this.choice = ""
      this.showConfirmation = false
			this.showSelected=false
		},
    confirmSelection(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let icon = this.choice
        this.$store
          .dispatch("user/pickiconCampaign", { account_id, auth_token,  icon})
          .then(response => {
            if (response.success == true) {
							this.showConfirmation = false
              this.showSelected = true
							this.eurocupCheck()
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }else{
        $("#modal-login").modal("show")
      }
    },
		eurocupCheck(){
			if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/pickiconcampaignCheck", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                if(response.data[0].locked == true){
									this.locked = true
									if(response.data[0].icon !== null){
										this.choice = response.data[0].icon
									}else{
										this.choice = ""
									}
								}else{
									this.locked = false
								}
              }else{
								this.locked = true
              }
              this.startRender = false
            } else {
              this.startRender = false
							this.locked = true
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.startRender = false
						this.locked = true
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
		},
		hideSelected(){
			this.showSelected = false
		}
	}
}
</script>
<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

main {
  color: white;
  width: 400px;
  margin: 0 auto;
  /* background: url("/new/img/events/feb-2026/background.png"); */
  background-color: #602185;
  position: relative;
}

.fullBg{
  position: relative;
  max-width: 400px;
  margin: auto;
  padding-top: 70px;
}

body {
  /* max-width: 500px; */

  font-family: "Roboto", sans-serif;
  background-size: cover;
  background-position: center;
  color: white;
}

body .banner {
  background: url("/new/img/events/feb-2026/title/title-background.png");
  background-size: cover;
  background-position: center;
  padding: 0 0 0 0;
}

.banner {
  display: flex;
  flex-direction: column;
}

.banner .win-flowers {
  position: relative;
  bottom: 3rem;
  width: 100%;
  margin-top: 50px;
}

.banner .win-flowers .title-win-image {
  width: 100%;
}

.banner .title-image {
  width: 90%;
  margin: 0 auto;
  /* height: 250px; */
}

.win-flowers .flowers {
  display: flex;
  justify-content: space-between;
  width: 83%;
  position: absolute;
  bottom: -20px;
  left: 2.7rem;
}

.symbols-div {
  position: absolute;
  top: 1.5rem;
  left: 3.2rem;
  width: 80%;
  margin: 0 auto;
}

.lock-popup {
  /* display: none; */
  position: absolute;
  top: 0.6rem;
  left: 2.8rem;
  width: 80%;
  z-index: 9;
}
/* 
.selection-popup  {
  position: absolute;
  top: 0.6rem;
  left: 2.8rem;
  width: 80%;
  z-index: 9;
} */

.lock-popup .deposit-unlock-btn {
  cursor: pointer;
  position: absolute;
  width: 45%;
  height: 30px;
  margin: 0 auto;
  bottom: 15%;
  left: 28%;
}

.symbols-div .title {
  width: 90%;
  margin: 0 auto;
}

.symbols-box .box-with-flag {
  position: relative;
}

.symbols-box .box-with-flag .box-flag {
  width: 100%;
}

.symbols-grid {
  margin: 1rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 2rem;
}

.grid-title .grid-title-img {
  width: 100%;
}

.symbols-grid .symbol-box {
  position: relative;
  width: 80px;
}

.symbol-box .symbol {
  width: 100%;
}

.symbol-box .pick-btn {
  cursor: pointer;
  position: absolute;
  width: 60px;
  bottom: -10px;
  left: 10px;
}

.box-with-flag .title-win-left-flower,
.box-with-flag .title-win-right-flower {
  position: relative;
  bottom: 3rem;
  width: 65px;
  z-index: 100;
}

.box-with-flag .title-win-right-flower {
  left: 66%;
}

@media (max-width:480px) {
  main{
    width: 100%;
    max-width: 400px;
  }
  .fullBg{
    padding-top: 60px;
  }
}

@media screen and (max-width: 500px) {
  /* .symbols-grid {
    place-items: start;
    margin-left: 2.5rem;
    row-gap: 1.5rem;
  } */
  /* 
    .symbols-grid .symbol-box {
      position: relative;
      width: 80px;
    } */

  .symbol-box .pick-btn {
    width: 60px;
  }

  .box-with-flag .title-win-left-flower,
  .box-with-flag .title-win-right-flower {
    width: 60px;
  }

  .box-with-flag .title-win-right-flower {
    left: 70%;
  }
}

.selection-popup {
  background: url("/new/img/events/feb-2026/box_content/grey-tone-background.png");
  background-size: cover;
  background-position: center;
  /* display: flex; */
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2.5rem 0;
  height: 78%;
  position: absolute;
  top: 0.6rem;
  left: 2.8rem;
  width: 80%;
  z-index: 9;
}

.selection-popup .selection-recorded-img {
  width: 70%;
}

.chosen-symbol-popup,
.recorded-symbol-popup {
  width: 100%;
  display: none;
  background-color: rgba(20, 20, 86, 0.7);
  position: absolute;
  inset: 0;
  z-index: 999;
  height: 100%;
  /* display: flex; */
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.chosen-symbol-popup .actions {
  position: relative;
  bottom: 2.5rem;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.chosen-symbol-popup .actions img {
  cursor: pointer;
  width: 100px;
}

/* .recorded-symbol-popup .popup-img {
  /* width: 100%; */
.chosen-symbol-popup .popup-img .chosen-img,
.recorded-symbol-popup .popup-img .recorded-img {
  width: 100%;
}

.recorded-symbol-popup .popup-img .back-btn {
  cursor: pointer;
  width: 110px;
  position: relative;
  bottom: 5.2rem;
  left: 37%;
}

.t_c {
  background: var(--main-bg-color);
}

.t_c p {
  padding: 10px 16px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 13px;
}

</style>